/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseImageGenerationCallInProgressEventArgs = {
  prompt: string;
};

export type ResponseImageGenerationCallInProgressEvent = {
  type: "response.image_generation_call.in_progress";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  args?: ResponseImageGenerationCallInProgressEventArgs | undefined;
};

/** @internal */
export const ResponseImageGenerationCallInProgressEventArgs$inboundSchema:
  z.ZodType<
    ResponseImageGenerationCallInProgressEventArgs,
    z.ZodTypeDef,
    unknown
  > = z.object({
    prompt: z.string(),
  });
/** @internal */
export type ResponseImageGenerationCallInProgressEventArgs$Outbound = {
  prompt: string;
};

/** @internal */
export const ResponseImageGenerationCallInProgressEventArgs$outboundSchema:
  z.ZodType<
    ResponseImageGenerationCallInProgressEventArgs$Outbound,
    z.ZodTypeDef,
    ResponseImageGenerationCallInProgressEventArgs
  > = z.object({
    prompt: z.string(),
  });

export function responseImageGenerationCallInProgressEventArgsToJSON(
  responseImageGenerationCallInProgressEventArgs:
    ResponseImageGenerationCallInProgressEventArgs,
): string {
  return JSON.stringify(
    ResponseImageGenerationCallInProgressEventArgs$outboundSchema.parse(
      responseImageGenerationCallInProgressEventArgs,
    ),
  );
}
export function responseImageGenerationCallInProgressEventArgsFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseImageGenerationCallInProgressEventArgs,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseImageGenerationCallInProgressEventArgs$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseImageGenerationCallInProgressEventArgs' from JSON`,
  );
}

/** @internal */
export const ResponseImageGenerationCallInProgressEvent$inboundSchema:
  z.ZodType<ResponseImageGenerationCallInProgressEvent, z.ZodTypeDef, unknown> =
    z.object({
      type: z.literal("response.image_generation_call.in_progress"),
      sequence_number: z.number().int(),
      item_id: z.string(),
      output_index: z.number().int(),
      args: z.lazy(() =>
        ResponseImageGenerationCallInProgressEventArgs$inboundSchema
      ).optional(),
    }).transform((v) => {
      return remap$(v, {
        "sequence_number": "sequenceNumber",
        "item_id": "itemId",
        "output_index": "outputIndex",
      });
    });
/** @internal */
export type ResponseImageGenerationCallInProgressEvent$Outbound = {
  type: "response.image_generation_call.in_progress";
  sequence_number: number;
  item_id: string;
  output_index: number;
  args?: ResponseImageGenerationCallInProgressEventArgs$Outbound | undefined;
};

/** @internal */
export const ResponseImageGenerationCallInProgressEvent$outboundSchema:
  z.ZodType<
    ResponseImageGenerationCallInProgressEvent$Outbound,
    z.ZodTypeDef,
    ResponseImageGenerationCallInProgressEvent
  > = z.object({
    type: z.literal("response.image_generation_call.in_progress"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
    args: z.lazy(() =>
      ResponseImageGenerationCallInProgressEventArgs$outboundSchema
    ).optional(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
    });
  });

export function responseImageGenerationCallInProgressEventToJSON(
  responseImageGenerationCallInProgressEvent:
    ResponseImageGenerationCallInProgressEvent,
): string {
  return JSON.stringify(
    ResponseImageGenerationCallInProgressEvent$outboundSchema.parse(
      responseImageGenerationCallInProgressEvent,
    ),
  );
}
export function responseImageGenerationCallInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseImageGenerationCallInProgressEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseImageGenerationCallInProgressEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseImageGenerationCallInProgressEvent' from JSON`,
  );
}
